<template>
  <div class="recharge-qrcode">
    <span>{{ qrCodeText }}</span>
    <b @click="copyText">{{ $t('actions.copy') }}</b>
    <input type="text" v-model="renderData[conf.key]" ref="input" />
    <div class="recharge-qrcode-content">
      <div>
        <v-progress-circular v-if="!qrCodeReady" indeterminate color="primary"></v-progress-circular>
        <span v-show="conf.withQrCode && qrCodeReady" ref="QrCode"></span>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
import commonMixin from '@/common/mixin/common';

export default {
  name: 'GQrCode',
  components: {},
  props: ['conf', 'renderData'],
  mixins: [commonMixin],
  data() {
    return {
      qrCodeReady: false
    };
  },
  computed: {
    qrCodeText() {
      return this.renderData[this.conf.key];
    }
  },
  watch: {
    qrCodeText: {
      immediate: true,
      handler() {
        if (this.conf.withQrCode) {
          this.draw();
        }
      }
    }
  },
  mounted() {
    this.draw();
  },
  methods: {
    copyText() {
      this.$refs.input.select();
      document.execCommand('copy');
      this.successNotify(this.$t('success.copy'));
    },
    draw() {
      const ref = this.$refs.QrCode;
      if (ref) {
        ref.innerHTML = '';
        const qrCode = new QRCode(ref, {
          text: this.qrCodeText,
          width: 124,
          height: 124,
          colorDark: '#000000', // 显示颜色
          colorLight: '#ffffff', // 背景颜色
          correctLevel: QRCode.CorrectLevel.H // 质量高度
        });
        this.qrCodeReady = true;
      }
    }
  }
};
</script>
<style scoped>
.recharge-qrcode-content {
  padding-left: 20px;
  flex: 1 0 0;
  display: flex;
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
}
.recharge-qrcode-content > div:last-child {
  flex: 1 1 0px;
  padding: 0 20px;
  /*overflow: hidden;*/
  height: 25px;
  transition: all 0.5s;
}
.recharge-qrcode-content > div:last-child span {
  display: inline-block;
  padding: 5px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.16);
  opacity: 1;
}
/*.recharge-qrcode-content > div:last-child:hover{*/
/*height: 145px;*/
/*padding: 10px 20px;*/
/*}*/
.recharge-qrcode {
  display: flex;
  height: 25px;
  line-height: 25px;
  position: relative;
}

.recharge-qrcode > span {
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
  flex: 0 1 60%;
}

.recharge-qrcode > b {
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  font-weight: normal;
  cursor: pointer;
}

.recharge-qrcode > input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
</style>
